module.exports = __webpack_public_path__ + "img/1zh7xOyAIgMeKfQ3eJ2Tfn-7rs_nBQmK2.942a0c35.png";